import MicroServiceCallError from './microservice-call-error';

export default class MicroServiceCallInvalidService extends MicroServiceCallError {
	constructor(statusCode, statusMessage, headers, body) {
		super(statusCode, statusMessage, headers, body);
		this.name = 'MicroServiceCallInvalidService';
	}
}
